import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import selectSelectedProductLot from '../productDetails/selectSelectedProductLot';

const selectProtectionPlan = memoize((sourceMiniPDP) =>
    createSelector([selectSelectedProductLot(sourceMiniPDP)], (selectedProductLot) => {
        let result = [];
        /* istanbul ignore else */
        if (
            selectedProductLot.length &&
            selectedProductLot[0].warranties &&
            selectedProductLot[0].warranties.length
        ) {
            result = selectedProductLot[0].warranties;
        }
        return result;
    })
);

export default selectProtectionPlan;
